import { Instance as companyAccountingSoftwareService } from '../services/companyAccountingSoftware';

/**
 * Get name of accounting software package for the current company.
 */
export function getAccountingSoftwareName(): string {
  const accountingSoftware = companyAccountingSoftwareService.softwarePackage;
  return accountingSoftware?.name ?? '';
}
